<template>
  <Html
    :lang="head.htmlAttrs.lang"
    :dir="head.htmlAttrs.dir"
  >
    <slot />
  </Html>
</template>

<script setup>
  const head = useLocaleHead()
  const { t: $t } = useI18n()

  useHead({
    meta: [
      ...head.value.meta,
      { property: 'og:title', content: $t('seo.home_page.title') },
      { property: 'og:description', content: $t('seo.home_page.description') },
    ],
    link: head.value.link,
  })
</script>
